import script from "./ClientCabinetFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientCabinetFilter.vue?vue&type=script&setup=true&lang=js"

import "./ClientCabinetFilter.vue?vue&type=style&index=0&id=3660efd6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3660efd6"]])

export default __exports__